import { UPDATE_PERSISTED_VM_STATE } from '../types';
import { takeLatest, put, select } from 'redux-saga/effects';
import { get } from 'lodash';
import actions from './actions';
import types from './types';
import selector from './selectors';
import { getMetricTable, getMetricsFromList } from './helpers';

function* initBase(action) {
  // persistence action is common
  // ignore if triggered from another tab
  const key = get(action, ['response', 'key'], null);
  const { meta = {} } = action;

  if (key !== '/vm') {
    return;
  }
  const persistedVM = get(action, ['response', 'configuration', 'vm'], null);
  if (persistedVM && persistedVM !== null) {
    const tableColumns = getMetricTable(persistedVM.selectedColumns);
    yield put(actions.updateBase({ selectedColumns: tableColumns }));
    yield put(actions.updateBase({ advanceToggle: persistedVM.advanceToggle }));
  }
  if ('doneCallback' in meta) {
    meta.doneCallback();
  }
}
// Persist only table selected columns
function* triggerPersistence({ notUpdatePersistence }) {
  if (notUpdatePersistence) {
    return;
  }

  const baseState = yield select(selector);
  const selectedMetricList = baseState.selectedColumns;
  const metricsList = getMetricsFromList(selectedMetricList);
  yield put(
    actions.persistState({
      vm: { selectedColumns: metricsList, advanceToggle: baseState.advanceToggle },
    }),
  );
}

function* watchPersistedState() {
  yield takeLatest([UPDATE_PERSISTED_VM_STATE], initBase);
}

// actions to watch for persistence
function* watchActions() {
  yield takeLatest([types.SET_SELECTED_COLUMNS, types.SET_ADVANCED_TOGGLE], triggerPersistence);
}

export default [watchPersistedState, watchActions];
